import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Link from 'next/link';
import { Title } from '../PostSidebarStyled';
import Text from '../Shared/Text';
import { ISidebarCategoriesProps } from './interfaces';

const SidebarCategories: React.FC<ISidebarCategoriesProps> = ({
  categories,
  currentSlug,
}) => {
  return (
    <Box mt={6}>
      <Title>CATEGORIES</Title>
      <Flex direction="column">
        {categories.map(({ slug, title, count }) => (
          <Link href={`/category/${slug}`} key={slug} passHref>
            <Text isBold={slug === currentSlug}>{`${title} (${count})`}</Text>
          </Link>
        ))}
      </Flex>
    </Box>
  );
};

export default SidebarCategories;
